<template >
  <!-- About Start -->
  <section id="about" class="about">
    <div class="about-decor">
      <div class="about-circle1"><img :src='"../assets/images/team1.png"' alt="team1"></div>
      <div class="about-circle2"><img :src='"../assets/images/main-banner1.png"' alt="banner1"></div>
    </div>
    <div class="container">
      <div class="row ">
        <div class="col-md-5">
          <div class="about-contain">
            <div>
              <h2 class="title">Sobre o<span> sistema</span></h2>
              <p class="caption-about">Nosso sistema é completo e auto instalável, simples de usar e
                atende a todas as necessidades de emissão de documentos fiscais eletrônicos.</p>
              <div class="row sm-mb">
                <div class="col-6">
                  <ul class="about-style">
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img :src='"../assets/images/icon1.png"' alt="easy-to-customized">
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>NFC-e</h3>
                      </div>
                    </li>
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img :src='"../assets/images/icon3.png"' alt="easy-to-use">
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>NF-e</h3>
                      </div>
                    </li>
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img :src='"../assets/images/icon3.png"' alt="easy-to-use">
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>SAT</h3>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-6">
                  <ul class="about-style">
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img :src='"../assets/images/icon2.png"' alt="Awasome-Design">
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>MF-e</h3>
                      </div>
                    </li>
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img :src='"../assets/images/icon4.png"' alt="SEO-Friendly">
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>MDF-e</h3>
                      </div>
                    </li>
                    <li class="abt-hover">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img :src='"../assets/images/icon4.png"' alt="SEO-Friendly">
                        </div>
                      </div>
                      <div class="about-text">
                        <h3>CT-e</h3>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="top-margin">
                <button type="button" onclick="location.href='#business'"
                  class="btn btn-custom theme-color theme-color">view more</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7 d-medium-none">
          <div class="about-right">
            <div class="about-phone">
              <img :src='"../assets/images/aboutus.png"' class="img-fluid" alt="aboutus">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- About End -->
</template>
<script>
export default {
  name: 'about'
}
</script>
<style scoped>
.about-right {
  background: linear-gradient(to bottom, #18e7d3 0, #1b4355 99%) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue